import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './plugins/base'
// import './plugins/chartist'
// import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

import CareConnect from './plugins/careConnect'

Vue.use(CareConnect, {
  mainEndpoint: process.env.VUE_APP_MAIN_API_ENDPOINT,
  adminEndpoint: process.env.VUE_APP_ADMIN_API_ENDPOINT,
  adpEndpoint: process.env.VUE_APP_ADP_API_ENDPOINT,
})

Vue.config.productionTip = false

const baseTitle = 'CareConnect Admin'
const stage = process.env.VUE_APP_STAGE
document.title = (!stage || stage === 'prod')
  ? baseTitle
  : `${baseTitle} | ${stage.toUpperCase()}`

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
